import CodexCard from '../CodexCard/CodexCard';
import styles from './CodexGrid.module.css';

export default function CodexGrid({ codices, onOpen, onPatch }) {
  return (
    <div className={styles.grid}>
      {codices.map((c) => (
        <CodexCard 
          key={c.id} 
          codex={c} 
          onOpen={onOpen} 
          onPatch={onPatch}
        />
      ))}
    </div>
  );
}